import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import HttpApis from "../../services/HttpApis";
import { isPlausibleEmail as validateEmail } from "../../utils/validateEmail";
import { Notyf } from "notyf";
import "notyf/notyf.min.css";
import * as Styled from "../Login/style";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { useTenant } from "../../TenantContext";

const NewPassword = () => {
  const { logo } = useTenant();
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const notyf = new Notyf({ position: { x: "center", y: "center" } });


  useEffect(() => {
    const storedEmail = location.state?.email || localStorage.getItem("resetPasswordEmail");
    const storedOtp = location.state?.otp || localStorage.getItem("resetPasswordOtp");

    if (storedEmail) {
      setEmail(storedEmail);
      localStorage.setItem("resetPasswordEmail", storedEmail);
    }
    if (storedOtp) {
      setOtp(storedOtp);
      localStorage.setItem("resetPasswordOtp", storedOtp);
    }
  }, [location]);

  useEffect(() => {
    const handlePopState = (e) => {
      e.preventDefault();
      window.history.pushState(null, '', window.location.pathname);
    };

    window.history.pushState(null, '', window.location.pathname);
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSubmit();
    }
  };

  const handleSubmit = async () => {
    setError("");
    setMessage("");

    if (!email) {
      setError("Email cannot be empty");
      return;
    }

    if (!validateEmail(email)) {
      setError("Invalid email format");
      return;
    }

    if (!newPassword) {
      setError("New password cannot be empty");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("email", email);
      formData.append("otp", otp);
      formData.append("new_password", newPassword);

      const response = await HttpApis.resetPassword(formData);

      if (response.status === 200) {
        setMessage("Password updated successfully!");
        notyf.success("Password updated successfully!");
        localStorage.setItem("loginEmail", email);
        localStorage.removeItem("resetPasswordEmail");
        localStorage.removeItem("resetPasswordOtp");
        navigate("/login", { state: { email: email }, replace: true });
      } else {
        setError("Failed to update password");
      }
    } catch (err) {
      if (err.errors) {
        const errorMessages = Object.values(err.errors).flat();
        setError(errorMessages.join(', '));
      } else if (err.message) {
        setError(err.message);
      } else if (err.response?.data?.errors) {
        const errorMessages = Object.values(err.response.data.errors).flat();
        setError(errorMessages.join(', '));
      } else if (err.response?.data?.message) {
        setError(err.response.data.message);
      } else {
        setError("An error occurred. Please try again.");
      }
    }
  };

  return (
    <Styled.LoginContainer>
      <Styled.MainContainer className="container">
        <div className="logo-container">
          <img src={logo} alt="Logo" className="logo" />
        </div>
        <div className="formContainer">
          <p className="para">Reset your password</p>
          <input
            placeholder="Email"
            className="inputBox"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onKeyDown={handleKeyDown}
            disabled={true}
            style={{ opacity: 0.6, cursor: "not-allowed" }}
          />
          <Styled.PasswordContainer>
            <input
              placeholder="New Password"
              type={showNewPassword ? "text" : "password"}
              className="inputBox"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              onKeyDown={handleKeyDown}
            />
            <span className="eyeIcon" onClick={() => setShowNewPassword(!showNewPassword)}>
              {showNewPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
            </span>
          </Styled.PasswordContainer>
          {error && <p className="errorText">{error}</p>}
          {message && <p className="successText">{message}</p>}
          <Button
            className="btn"
            onClick={handleSubmit}
            style={{ backgroundColor: "var(--brand, #B87333)", borderColor: "var(--brand, #B87333)" }}
          >
            Submit
          </Button>
        </div>
        <div className="paraText clickable" onClick={() => {
          navigate("/Login")
        }} style={{ cursor: "pointer" }}>
          <span><MdKeyboardArrowLeft className="arrowIcon" /></span> Go Back
        </div>
      </Styled.MainContainer>
    </Styled.LoginContainer>
  );
};

export default NewPassword;
